exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-payments .payment-img[data-v-1795e1ac]{width:40px;height:35px;margin:2px;display:flex;align-items:center;justify-content:center}.footer-payments .payment-img img[data-v-1795e1ac]{max-height:100%}", ""]);

// exports
